import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Card, CardTitle } from '../../styles/SharedStyles';

ChartJS.register(ArcElement, Tooltip, Legend);

const CostByTagChart = () => {
  const data = {
    labels: ['Dev', 'Entertainment', 'Utilities', 'Tools'],
    datasets: [
      {
        data: [35, 35, 15, 15],
        backgroundColor: [
          '#000000',
          '#2A9D8F',
          '#8ECAE6',
          '#666666'
        ],
        hoverBackgroundColor: [
          '#000000',
          '#2A9D8F',
          '#8ECAE6',
          '#666666'
        ],
        borderWidth: 0
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 20,
          usePointStyle: true,
          pointStyle: 'circle'
        }
      }
    }
  };

  return (
    <Card>
      <CardTitle>
        <span>🏷️</span>
        Subscriptions Costs per Tag
      </CardTitle>
      <div style={{ height: '300px', width: '100%', position: 'relative' }}>
        <Pie data={data} options={options} />
      </div>
    </Card>
  );
};

export default CostByTagChart; 